import React from "react";

import { Button } from "../helper";

const useStyle = (width, bg, color, borderColor, gutter) => ({
  buttonStyle: (theme) => ({
    margin: theme.spacing(...gutter),
    borderRadius: theme.spacing(4),
    textTransform: "none",
    height: 56,
    fontWeight: 600,
    fontSize: 14,
    backgroundColor: bg,
    color: color,
    width: width,
    padding: 1,
    border: `1px solid ${borderColor}`,
  }),
});

export default function ChallanPopperButton({
  width,
  bg,
  color,
  borderColor,
  gutter,
  ...rest
}) {
  const style = useStyle(width, bg, color, borderColor, gutter);

  return <Button sx={style.buttonStyle} {...rest} />;
}

ChallanPopperButton.defaultProps = {
  width: "100%",
  bg: "#fff",
  color: "#E2136E",
  borderColor: "rgba(224, 224, 224, 1)",
  gutter: [0],
};
